import React, { useState } from "react";
import axios from "../utils/axiosConfig.js";
import { toast } from "react-toastify";
import { checkAllDuplicates } from "../utils/duplicateDetection.js";
import "./Export.css";

const API_URL = process.env.REACT_APP_API_URL;

const ImportRegistrations = () => {
  const [emailText, setEmailText] = useState("");
  const [parsedStudents, setParsedStudents] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [importing, setImporting] = useState(false);
  const [existingStudents, setExistingStudents] = useState([]);
  const [duplicates, setDuplicates] = useState([]);
  const [duplicateWarnings, setDuplicateWarnings] = useState([]);
  const [duplicatesWithinBatch, setDuplicatesWithinBatch] = useState([]);

  const parseEmailData = async () => {
    if (!emailText.trim()) {
      alert("Bitte E-Mail-Text eingeben!");
      return;
    }

    try {
      const students = [];

      // Split by multiple blank lines or "---" separator to handle multiple registrations
      const registrations = emailText
        .split(/\n\s*\n\s*\n|\n\s*---\s*\n/)
        .filter((r) => r.trim());

      console.log(`Found ${registrations.length} potential registration(s)`);

      registrations.forEach((regText, regIndex) => {
        console.log(`\n=== Processing registration ${regIndex + 1} ===`);

        const student = {
          firstName: "",
          lastName: "",
          birthDate: "",
          email: "",
          phone: "",
          adress: "",
          member: false,
          adult: null, // Will be auto-detected
          trainigGroup: "",
          skillLevel: "",
          sex: "",
          frequence: "",
          team: false,
          groupSize: "",
          comment2: "",
          availableTimes: [],
          comment: "",
        };

        const lines = regText.split("\n").map((l) => l.trim());

        let currentField = "";
        let currentDay = "";
        let firstNonFieldLine = "";
        let groupSizeSelections = [];

        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];

          if (!line) continue;

          // Ignore footer/tracking lines and email headers
          if (
            line.includes("Gesendet von TC GW Am Kreuzberg") ||
            line.includes("Neue Trainingsanmeldung") ||
            line.includes("Neue Anmeldung") ||
            line.includes("Foto des Kontakts") ||
            line.includes("Von TC GW Am Kreuzberg") ||
            line.includes("Details Kopfzeilen") ||
            line.includes("HTML") ||
            line.includes("<Club@TC-Kreuzberg.de>") ||
            line.includes("am 202") || // Catches "am 2025-10-06"
            line === "Links:" ||
            line.startsWith("http://") ||
            line.startsWith("https://") ||
            line.startsWith("------") ||
            line.startsWith("Feld ID")
          ) {
            continue;
          }

          // Capture full name if it's the first non-empty line before any field
          if (
            !firstNonFieldLine &&
            !currentField &&
            line &&
            !line.includes("E-Mail") &&
            !line.includes("Adresse") &&
            !line.includes("Telefon") &&
            !line.includes("Mitglied") &&
            !line.includes("Spielstärke") &&
            !line.includes("Trainingsart") &&
            !line.includes("http") &&
            !line.includes("@") &&
            !line.includes("*")
          ) {
            firstNonFieldLine = line;
          }

          // Detect field names
          if (line === "Name" || line === "Name *") {
            currentField = "Name";
            continue;
          } else if (line === "Vorname") {
            currentField = "Vorname";
            continue;
          } else if (line === "Nachname") {
            currentField = "Nachname";
            continue;
          } else if (line === "Geburtsdatum") {
            currentField = "Geburtsdatum";
            continue;
          } else if (
            line.includes("E-Mail-Adresse") ||
            line === "E-Mail" ||
            line === "Email"
          ) {
            currentField = "Email";
            continue;
          } else if (line.includes("Telefonnummer") || line === "Telefon") {
            currentField = "Telefon";
            continue;
          } else if (line === "Adresse" || line === "Adresse *") {
            currentField = "Adresse";
            continue;
          } else if (
            line.includes("Mitgliedsstatus") ||
            line.includes("Mitglied (")
          ) {
            currentField = "Mitgliedsstatus";
            continue;
          } else if (line.includes("Spielstärke")) {
            currentField = "Spielstärke";
            continue;
          } else if (line.includes("Ziel des Trainings")) {
            currentField = "Ziel";
            continue;
          } else if (line.includes("Anzahl Mitspieler")) {
            currentField = "AnzahlMitspieler";
            continue;
          } else if (line === "Trainingsart") {
            currentField = "Trainingsart";
            continue;
          } else if (line.includes("Trainingshäufigkeit")) {
            currentField = "Trainingshäufigkeit";
            continue;
          } else if (
            line.includes("spiele im Winter") ||
            line.includes("Team (Rot, Orange")
          ) {
            currentField = "Team";
            continue;
          } else if (
            (line.includes("Montag") || line.includes("Montags")) &&
            (line.includes("KANN") || line.includes("kann ich"))
          ) {
            currentDay = "Montag";
            currentField = "AvailableTimes";
            continue;
          } else if (
            (line.includes("Dienstag") || line.includes("Dienstags")) &&
            (line.includes("KANN") || line.includes("kann ich"))
          ) {
            currentDay = "Dienstag";
            currentField = "AvailableTimes";
            continue;
          } else if (
            (line.includes("Mittwoch") || line.includes("Mittwochs")) &&
            (line.includes("KANN") || line.includes("kann ich"))
          ) {
            currentDay = "Mittwoch";
            currentField = "AvailableTimes";
            continue;
          } else if (
            (line.includes("Donnerstag") || line.includes("Donnerstags")) &&
            (line.includes("KANN") || line.includes("kann ich"))
          ) {
            currentDay = "Donnerstag";
            currentField = "AvailableTimes";
            continue;
          } else if (
            (line.includes("Freitag") || line.includes("Freitags")) &&
            (line.includes("KANN") || line.includes("kann ich"))
          ) {
            currentDay = "Freitag";
            currentField = "AvailableTimes";
            continue;
          } else if (
            (line.includes("Samstag") || line.includes("Samstags")) &&
            (line.includes("KANN") || line.includes("kann ich"))
          ) {
            currentDay = "Samstag";
            currentField = "AvailableTimes";
            continue;
          } else if (line === "Bemerkungen" || line.includes("Zusätzliche Bemerkungen")) {
            currentField = "Bemerkungen";
            continue;
          }

          // Parse values based on current field
          switch (currentField) {
            case "Name":
              if (!student.firstName && !student.lastName) {
                const nameParts = line.trim().split(/\s+/);
                if (nameParts.length >= 2) {
                  student.firstName = nameParts[0];
                  student.lastName = nameParts.slice(1).join(" ");
                } else if (nameParts.length === 1) {
                  student.firstName = nameParts[0];
                }
                currentField = "";
              }
              break;
            case "Vorname":
              if (!student.firstName) {
                student.firstName = line;
                currentField = "";
              }
              break;
            case "Nachname":
              if (!student.lastName) {
                student.lastName = line;
                currentField = "";
              }
              break;
            case "Geburtsdatum":
              if (!student.birthDate) {
                student.birthDate = line;
                currentField = "";
              }
              break;
            case "Email":
              if (!student.email && line.includes("@")) {
                student.email = line;
                currentField = "";
              }
              break;
            case "Telefon":
              if (!student.phone && /\d/.test(line)) {
                student.phone = line;
                currentField = "";
              }
              break;
            case "Adresse":
              if (!student.adress && line.length > 3) {
                student.adress = line;
                currentField = "";
              }
              break;
            case "Mitgliedsstatus":
              if (
                line.includes("Mitglied") &&
                !line.includes("Nicht-Mitglied") &&
                !line.includes("Kein Mitglied")
              ) {
                student.member = true;
                currentField = "";
              } else if (
                line.includes("Kein Mitglied") ||
                line.includes("Nicht-Mitglied") ||
                line.includes("Schnupperkind")
              ) {
                student.member = false;
                currentField = "";
              }
              break;
            case "Spielstärke":
              const skillLine = line.toLowerCase();
              if (
                skillLine.includes("anfänger mit grundkenntnissen") ||
                skillLine.includes("anfänger mit vorkenntnissen")
              ) {
                // Map both "Grundkenntnissen" and "Vorkenntnissen" to the same value
                student.skillLevel = "Anfänger mit Grundkenntnissen";
                student.adult = true;
              } else if (
                skillLine.includes("anfänger") &&
                !skillLine.includes("grundkenntnissen") &&
                !skillLine.includes("vorkenntnissen")
              ) {
                student.skillLevel = "Anfänger";
                student.adult = true;
              } else if (
                skillLine.includes("fortgeschritten") ||
                skillLine.includes("fortgescritten")
              ) {
                // Accept both "fortgeschritten" and "fortgescritten" (typo)
                student.skillLevel = "Fortgeschritten";
                student.adult = true;
              } else if (skillLine.includes("wenig fortgeschritten")) {
                student.skillLevel = "wenig Fortgeschritten";
                student.adult = true;
              } else if (
                skillLine.includes("erfahrene spieler") ||
                skillLine.includes("mannschaftsspieler")
              ) {
                student.skillLevel =
                  "Erfahrene Spieler:innen / Mannschaftsspieler:innen";
                student.adult = true;
              } else if (
                skillLine.includes("leistungsspieler") ||
                skillLine.includes("turnierspieler")
              ) {
                student.skillLevel =
                  "Leistungsspieler:innen / Turnierspieler:innen";
                student.adult = true;
              } else if (skillLine.includes("gute")) {
                student.skillLevel = "gute:r Spieler:in";
                student.adult = true;
              }
              if (student.adult) currentField = "";
              break;
            case "Ziel":
              if (line && !line.includes("Ziel des Trainings")) {
                if (student.comment2) {
                  student.comment2 += ", " + line;
                } else {
                  student.comment2 = line;
                }
              }
              break;
            case "AnzahlMitspieler":
              if (
                line &&
                !line.includes("Anzahl Mitspieler") &&
                !line.includes("Mehrfachauswahl")
              ) {
                const lowerLine = line.toLowerCase();
                if (lowerLine.includes("einzeltraining")) {
                  groupSizeSelections.push(1);
                } else if (lowerLine.includes("zu zweit")) {
                  groupSizeSelections.push(2);
                } else if (lowerLine.includes("zu dritt")) {
                  groupSizeSelections.push(3);
                } else if (lowerLine.includes("zu viert")) {
                  groupSizeSelections.push(4);
                } else if (lowerLine.includes("mannschaftstraining")) {
                  student.team = true;
                  groupSizeSelections.push(4); // Count for frequence
                }
              }
              break;
            case "Trainingsart":
              const artLine = line.toLowerCase();
              if (artLine.includes("kindergarten")) {
                student.trainigGroup = "Kinderland";
                student.adult = false;
                currentField = "";
              } else if (
                artLine.includes("kids-rot") ||
                artLine.includes("rot (")
              ) {
                student.trainigGroup = "Rot";
                student.adult = false;
                currentField = "";
              } else if (
                artLine.includes("kids-orange") ||
                artLine.includes("orange (")
              ) {
                student.trainigGroup = "Orange";
                student.adult = false;
                currentField = "";
              } else if (
                artLine.includes("kids-grün") ||
                artLine.includes("grün (")
              ) {
                student.trainigGroup = "Grün";
                student.adult = false;
                currentField = "";
              } else if (
                artLine.includes("jugend hobby") ||
                (artLine.includes("gelb)") && artLine.includes("hobby"))
              ) {
                student.trainigGroup = "Gelb Hobby";
                student.adult = false;
                currentField = "";
              } else if (
                artLine.includes("jugend team") ||
                (artLine.includes("gelb") && artLine.includes("team"))
              ) {
                student.trainigGroup = "Gelb Team";
                student.adult = false;
                currentField = "";
              }
              break;
            case "Trainingshäufigkeit":
              if (line.includes("1x")) {
                student.frequence = "1";
                currentField = "";
              } else if (line.includes("2x")) {
                student.frequence = "2";
                currentField = "";
              }
              break;
            case "Team":
              if (line.toLowerCase() === "ja") {
                student.team = true;
                currentField = "";
              } else if (line.toLowerCase() === "nein" || line === "-") {
                student.team = false;
                currentField = "";
              }
              break;
            case "AvailableTimes":
              // Check if line contains hour in either format
              const hourMatchUhr = line.match(/(\d{1,2})\s*Uhr/);
              const hourMatchColon = line.match(/(\d{1,2}):00/);
              if ((hourMatchUhr || hourMatchColon) && currentDay) {
                const hour = hourMatchUhr ? hourMatchUhr[1] : hourMatchColon[1];
                student.availableTimes.push(`${currentDay} ${hour}`);
              }
              break;
            case "Bemerkungen":
              // Collect multi-line comments
              // Skip lines that look like field IDs or field headers
              if (!line.startsWith("Feld ID") && !line.includes("Bemerkungen")) {
                if (student.comment) {
                  student.comment += " " + line;
                } else {
                  student.comment = line;
                }
              }
              break;
          }
        }

        // Handle full name parsing if no separate firstName/lastName found
        if (!student.firstName && !student.lastName && firstNonFieldLine) {
          const nameParts = firstNonFieldLine.trim().split(/\s+/);
          if (nameParts.length >= 2) {
            student.firstName = nameParts[0];
            student.lastName = nameParts.slice(1).join(" ");
          } else if (nameParts.length === 1) {
            student.firstName = nameParts[0];
          }
        }

        // Set groupSize and frequence from groupSizeSelections
        if (groupSizeSelections.length > 0) {
          student.groupSize = String(Math.max(...groupSizeSelections));
          student.frequence = String(groupSizeSelections.length);
        }

        // Auto-detect adult/child if not yet set
        if (student.adult === null) {
          if (student.skillLevel || student.comment2) {
            student.adult = true;
          } else if (student.trainigGroup) {
            student.adult = false;
          } else {
            student.adult = false; // Default to child
          }
        }

        // Only add if we have at least a name
        if (student.firstName || student.lastName) {
          console.log(`Student parsed:`, student);
          students.push(student);
        } else {
          console.log(
            `No valid student data found in registration ${regIndex + 1}`
          );
        }
      });

      console.log(`\nTotal students parsed: ${students.length}`);

      // Fetch existing students for duplicate check
      const { data: currentStudents } = await axios.get(
        `${API_URL}/api/students`
      );

      // Check for duplicates using improved detection
      const {
        duplicatesAgainstDB,
        duplicatesWithinBatch,
        warnings,
        hasDuplicates,
        hasWarnings,
      } = checkAllDuplicates(students, currentStudents);

      // Map duplicates back to student list format for UI
      const duplicatesList = duplicatesAgainstDB.map((dup) => dup.newStudent);

      // Validate required fields & available times
      students.forEach((student) => {
        student.warnings = [];
        if (!student.firstName) student.warnings.push("Vorname fehlt");
        if (!student.lastName) student.warnings.push("Nachname fehlt");
        if (student.adult) {
          if (!student.email) student.warnings.push("E-Mail fehlt");
          if (!student.phone) student.warnings.push("Telefon fehlt");
          if (!student.adress) student.warnings.push("Adresse fehlt");
          if (!student.skillLevel) student.warnings.push("Spielstärke fehlt");
          if (student.availableTimes.length < 5) {
            student.warnings.push(
              `Nur ${student.availableTimes.length} Zeiten (mind. 5 empfohlen)`
            );
          }
        } else {
          // Children validation
          if (!student.email) student.warnings.push("E-Mail fehlt");
          if (!student.phone) student.warnings.push("Telefon fehlt");
          if (!student.adress) student.warnings.push("Adresse fehlt");
          if (!student.trainigGroup)
            student.warnings.push("Trainingsgruppe fehlt");
          if (student.availableTimes.length < 5) {
            student.warnings.push(
              `Nur ${student.availableTimes.length} Zeiten (mind. 5 empfohlen)`
            );
          }
        }
      });

      setDuplicates(duplicatesAgainstDB);
      setDuplicatesWithinBatch(duplicatesWithinBatch);
      setDuplicateWarnings(warnings);
      setExistingStudents(currentStudents);
      setParsedStudents(students);
      setShowPreview(true);

      if (students.length === 0) {
        toast.warning(
          "Keine Schüler gefunden. Bitte überprüfen Sie das Format."
        );
      } else if (hasDuplicates) {
        const totalDups = duplicatesAgainstDB.length + duplicatesWithinBatch.length;
        toast.error(
          `⚠️ ${totalDups} Duplikat(e) gefunden! Import blockiert.`,
          { autoClose: 5000 }
        );
      } else if (hasWarnings) {
        toast.warning(
          `⚡ ${warnings.length} mögliche Duplikate gefunden (z.B. Geschwister). Bitte prüfen.`,
          { autoClose: 5000 }
        );
        toast.success(
          `${students.length} neue Schüler bereit zum Importieren.`
        );
      } else {
        toast.success(
          `${students.length} neue Schüler bereit zum Importieren.`
        );
      }
    } catch (error) {
      console.error("Fehler beim Parsen:", error);
      toast.error(`Fehler beim Parsen: ${error.message}`);
    }
  };

  const handleImport = async () => {
    if (parsedStudents.length === 0) {
      toast.warning("Keine Daten zum Importieren");
      return;
    }

    // Block import if duplicates exist
    if (duplicates.length > 0 || duplicatesWithinBatch.length > 0) {
      toast.error(
        "Import nicht möglich! Bitte entfernen Sie die Duplikate aus dem Eingabetext."
      );
      return;
    }

    if (!window.confirm(`${parsedStudents.length} Schüler importieren?`)) {
      return;
    }

    setImporting(true);
    try {
      const importPromises = parsedStudents.map((student) =>
        axios.post(`${API_URL}/api/students`, student)
      );

      await Promise.all(importPromises);
      toast.success(
        `✅ ${parsedStudents.length} Schüler erfolgreich importiert!`
      );

      // Clear form
      setEmailText("");
      setParsedStudents([]);
      setShowPreview(false);
      setDuplicates([]);
      setDuplicatesWithinBatch([]);
      setDuplicateWarnings([]);
      setExistingStudents([]);
    } catch (error) {
      console.error("Fehler beim Importieren:", error);
      toast.error("Fehler beim Importieren der Schüler!");
    } finally {
      setImporting(false);
    }
  };

  return (
    <div className="export-container">
      <h1>📧 Registrierungen importieren</h1>

      <div className="export-section">
        <h2>E-Mail-Daten eingeben</h2>
        <p>
          Fügen Sie den Inhalt der Registrierungs-E-Mails hier ein. Mehrere
          Registrierungen können mit Leerzeilen getrennt werden.
        </p>
        <textarea
          value={emailText}
          onChange={(e) => setEmailText(e.target.value)}
          placeholder="Name: Max&#10;Nachname: Mustermann&#10;Geburtsdatum: 01.01.2015&#10;Email: max@example.com&#10;..."
          style={{
            width: "100%",
            minHeight: "300px",
            padding: "15px",
            fontSize: "14px",
            fontFamily: "monospace",
            border: "2px solid #e0e0e0",
            borderRadius: "8px",
            boxSizing: "border-box",
            resize: "vertical",
          }}
        />
        <button
          className="export-button csv-button"
          onClick={parseEmailData}
          style={{ marginTop: "15px" }}
        >
          📋 Daten parsen
        </button>
      </div>

      {showPreview && parsedStudents.length > 0 && (
        <div className="export-section">
          <h2>Vorschau ({parsedStudents.length} Schüler)</h2>
          {(duplicates.length > 0 || duplicatesWithinBatch.length > 0) && (
            <div
              style={{
                padding: "15px",
                marginBottom: "15px",
                backgroundColor: "#fff3cd",
                border: "2px solid #ffc107",
                borderRadius: "8px",
                color: "#856404",
              }}
            >
              <strong>
                🚫 {duplicates.length + duplicatesWithinBatch.length} Duplikat(e)
                gefunden:
              </strong>
              <ul style={{ marginTop: "10px", marginBottom: "0", fontSize: "13px" }}>
                {duplicates.map((dup, idx) => (
                  <li key={idx} style={{ marginBottom: "8px" }}>
                    <strong>Zeile {dup.rowIndex + 1}:</strong> {dup.newStudent.firstName}{" "}
                    {dup.newStudent.lastName}
                    {dup.newStudent.birthDate && ` (${dup.newStudent.birthDate})`}
                    <br />
                    <span style={{ fontSize: "12px", color: "#666" }}>
                      → Bereits vorhanden: {dup.existingStudent.firstName}{" "}
                      {dup.existingStudent.lastName}
                      {dup.existingStudent.birthDate && ` (${dup.existingStudent.birthDate})`}
                    </span>
                    <br />
                    <span style={{ fontSize: "11px", fontStyle: "italic" }}>
                      Übereinstimmung: {dup.matchedFields.join(", ")} ({dup.reason})
                    </span>
                  </li>
                ))}
                {duplicatesWithinBatch.map((dup, idx) => (
                  <li key={`batch-${idx}`} style={{ marginBottom: "8px" }}>
                    <strong>CSV-Duplikat:</strong> {dup.student1.firstName}{" "}
                    {dup.student1.lastName}
                    {dup.student1.birthDate && ` (${dup.student1.birthDate})`}
                    <br />
                    <span style={{ fontSize: "12px", color: "#666" }}>
                      → Zeile {dup.row1 + 1} und Zeile {dup.row2 + 1}
                    </span>
                    <br />
                    <span style={{ fontSize: "11px", fontStyle: "italic" }}>
                      Übereinstimmung: {dup.matchedFields.join(", ")} ({dup.reason})
                    </span>
                  </li>
                ))}
              </ul>
              <p
                style={{
                  marginTop: "10px",
                  marginBottom: "0",
                  fontSize: "13px",
                }}
              >
                Import blockiert. Bitte entfernen Sie die Duplikate aus dem
                Eingabetext.
              </p>
            </div>
          )}
          {duplicateWarnings.length > 0 && (duplicates.length === 0 && duplicatesWithinBatch.length === 0) && (
            <div
              style={{
                padding: "15px",
                marginBottom: "15px",
                backgroundColor: "#e7f3ff",
                border: "2px solid #2196F3",
                borderRadius: "8px",
                color: "#0d47a1",
              }}
            >
              <strong>⚡ {duplicateWarnings.length} mögliche Duplikate (Warnungen):</strong>
              <ul style={{ marginTop: "10px", marginBottom: "0", fontSize: "13px" }}>
                {duplicateWarnings.slice(0, 5).map((warn, idx) => (
                  <li key={idx} style={{ marginBottom: "8px" }}>
                    <strong>Zeile {warn.rowIndex + 1}:</strong> {warn.newStudent.firstName}{" "}
                    {warn.newStudent.lastName}
                    {warn.newStudent.birthDate && ` (${warn.newStudent.birthDate})`}
                    <br />
                    <span style={{ fontSize: "12px", color: "#666" }}>
                      → Ähnlich: {warn.existingStudent.firstName}{" "}
                      {warn.existingStudent.lastName}
                      {warn.existingStudent.birthDate && ` (${warn.existingStudent.birthDate})`}
                    </span>
                    <br />
                    <span style={{ fontSize: "11px", fontStyle: "italic" }}>
                      {warn.reason}
                    </span>
                  </li>
                ))}
                {duplicateWarnings.length > 5 && (
                  <li style={{ fontSize: "12px", color: "#666" }}>
                    ... und {duplicateWarnings.length - 5} weitere Warnungen
                  </li>
                )}
              </ul>
              <p
                style={{
                  marginTop: "10px",
                  marginBottom: "0",
                  fontSize: "13px",
                }}
              >
                Diese sind möglicherweise keine echten Duplikate (z.B. Geschwister mit
                gleichem Nachnamen). Import ist möglich.
              </p>
            </div>
          )}
          <div style={{ overflowX: "auto", maxHeight: "400px" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "12px",
              }}
            >
              <thead>
                <tr
                  style={{ background: "#f0f0f0", position: "sticky", top: 0 }}
                >
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Status
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Typ
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Vorname
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Nachname
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Geburtsdatum
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    E-Mail
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Telefon
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Adresse
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Mitglied
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Level/Gruppe
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Team
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Gruppengröße
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Häufigkeit
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Verfügbare Zeiten
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Warnungen
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Ziel
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Bemerkungen
                  </th>
                </tr>
              </thead>
              <tbody>
                {parsedStudents.map((student, index) => {
                  // Check if this student is a duplicate
                  const isDuplicate =
                    duplicates.some((dup) => dup.rowIndex === index) ||
                    duplicatesWithinBatch.some(
                      (dup) => dup.row1 === index || dup.row2 === index
                    );
                  const isWarning = duplicateWarnings.some(
                    (warn) => warn.rowIndex === index
                  );

                  return (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: isDuplicate
                          ? "#fff3cd"
                          : isWarning
                          ? "#e7f3ff"
                          : "white",
                      }}
                    >
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        {isDuplicate
                          ? "🚫"
                          : isWarning
                          ? "⚡"
                          : student.warnings?.length > 0
                          ? "⚠️"
                          : "✅"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        {student.adult ? "👨 Erwachsen" : "👶 Kind"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        {student.firstName || "-"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        {student.lastName || "-"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        {student.birthDate || "-"}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          maxWidth: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {student.email || "-"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        {student.phone || "-"}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          maxWidth: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        title={student.adress}
                      >
                        {student.adress || "-"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        {student.member ? "Ja" : "Nein"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        {student.adult
                          ? student.skillLevel || "-"
                          : student.trainigGroup || "-"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        {student.team ? "Ja" : "Nein"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        {student.groupSize || "-"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        {student.frequence ? student.frequence + "x" : "-"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        {student.availableTimes.length} Zeiten
                      </td>
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          color: "#856404",
                        }}
                      >
                        {student.warnings?.length > 0
                          ? student.warnings.join(", ")
                          : "-"}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          maxWidth: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={student.comment2}
                      >
                        {student.comment2
                          ? student.comment2.substring(0, 40) +
                            (student.comment2.length > 40 ? "..." : "")
                          : "-"}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={student.comment}
                      >
                        {student.comment
                          ? student.comment.substring(0, 50) +
                            (student.comment.length > 50 ? "..." : "")
                          : "-"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <button
            className="export-button import-button"
            onClick={handleImport}
            disabled={importing || duplicates.length > 0 || duplicatesWithinBatch.length > 0}
            style={{
              marginTop: "15px",
              opacity: (duplicates.length > 0 || duplicatesWithinBatch.length > 0) ? 0.5 : 1,
              cursor: (duplicates.length > 0 || duplicatesWithinBatch.length > 0) ? "not-allowed" : "pointer",
            }}
            title={
              (duplicates.length > 0 || duplicatesWithinBatch.length > 0)
                ? "Import blockiert wegen Duplikaten"
                : duplicateWarnings.length > 0
                ? "Mögliche Duplikate gefunden - bitte prüfen"
                : ""
            }
          >
            {importing
              ? "⏳ Importiere..."
              : (duplicates.length > 0 || duplicatesWithinBatch.length > 0)
              ? `🚫 Import blockiert (${duplicates.length + duplicatesWithinBatch.length} Duplikat(e))`
              : duplicateWarnings.length > 0
              ? `⚡ ${parsedStudents.length} Schüler importieren (${duplicateWarnings.length} Warnungen)`
              : `✅ ${parsedStudents.length} Schüler importieren`}
          </button>
        </div>
      )}
    </div>
  );
};

export default ImportRegistrations;
